import * as amplify from "../util/amplify.ts";
import * as Html from "../util/Html.ts";
import * as FwDatas from "../FwDatas.ts";
import TPL from "../layout/familycenter.mustache";

export {init,destroy}

var current;
function init(me){
  current = me;
  var 
    maxDisplayCount = Math.floor(me.width()/60),
    families = FwDatas.getFamilies();
  
  families.forEach(function(fam0,idx){
    var
      famMaxDisplay = maxDisplayCount,
      needToDisplay = [].concat(fam0.members);
    if(idx===0){
      needToDisplay = needToDisplay.concat(fam0.invitations);
    }else{
      famMaxDisplay +=2;
    }
    
    if(needToDisplay.length>famMaxDisplay){
      //we remove one because we will diplay the +machin wich will take one place
      famMaxDisplay--;
      fam0.familyBarExtra = needToDisplay.length-famMaxDisplay;
    }else{
      fam0.familyBarExtra = undefined;
    }
    needToDisplay.forEach(function(member,idx){
      member.visibleInFamilyBar = idx<famMaxDisplay;
    })
    
  }); 
  Html.setHtml(me,TPL,{families})
}
function destroy(){
  current = undefined;
}
amplify.subscribe('resize',function(){
  if(current){
    init(current)
  }
})
Html.registerWidget('widget/familycenter',{init:init,destroy:destroy})